import * as TypeGraphQL from "type-graphql";
export var QueryMode;
(function (QueryMode) {
    QueryMode["default"] = "default";
    QueryMode["insensitive"] = "insensitive";
})(QueryMode || (QueryMode = {}));
TypeGraphQL.registerEnumType(QueryMode, {
    name: "QueryMode",
    description: undefined,
});
//# sourceMappingURL=QueryMode.js.map